interface INumberSeparators {
  thousandSeparator: string;
  decimalSeparator: string;
}

export const getSeparators = (): INumberSeparators => {
  const formattedNumber = new Intl.NumberFormat(navigator.language).format(
    1000
  );

  if (formattedNumber.includes(".")) {
    return {
      thousandSeparator: ".",
      decimalSeparator: ",",
    };
  }

  return {
    thousandSeparator: ",",
    decimalSeparator: ".",
  };
};

export const formatNumber = (
  number: number,
  options?: { minimumFractionDigits?: number }
): string => new Intl.NumberFormat(navigator.language, options).format(number);
